import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
import '../../styles/components/landing/TestimonialsSection.css';

const TestimonialsSection = ({ eyebrow, title, subtitle, items = [] }) => {
  if (!items.length) return null;

  return (
    <section id="testimonials" className="ls-testimonials">
      <div className="container">
        <div className="ls-testimonials__header">
          {eyebrow && <span className="ls-testimonials__eyebrow">{eyebrow}</span>}
          <h2 className="ls-testimonials__title">{title}</h2>
          {subtitle && <p className="ls-testimonials__subtitle">{subtitle}</p>}
        </div>

        <div className="ls-testimonials__grid">
          {items.map((t, i) => (
            <motion.figure
              key={i}
              className="ls-testimonials__card"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
            >
              <Quote className="ls-testimonials__quote" size={20} />
              <blockquote>{t.text}</blockquote>
              <figcaption>
                {t.avatar && (
                  <img
                    src={t.avatar}
                    alt=""
                    onError={(e) =>
                      (e.target.src = `https://ui-avatars.com/api/?background=random&name=${encodeURIComponent(
                        t.name || 'U'
                      )}`)
                    }
                  />
                )}
                <div>
                  <strong>{t.name}</strong>
                  {t.role && <span>{t.role}</span>}
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
